module.exports = __webpack_public_path__ + "static/media/21.9f3c78d6.jpeg";